import styled, { css } from 'styled-components';
import { colorCSS, cssColorsFromBackgroundField, radius, shadow } from '../../styles';
export const LinkItem = styled.button `
  ${({ selected, accentColor }) => selected
    ? css `
      ${cssColorsFromBackgroundField({ color: 'N0' })}}
      box-shadow: ${shadow.normal};
      ${accentColor &&
        css `
          &:after {
            background-color: ${colorCSS(accentColor === 'Magenta'
            ? 'M100'
            : `${accentColor.substring(0, 1)}200`)};
            border-radius: ${radius.button} 0 0 ${radius.button};
            bottom: 0;
            content: '';
            left: 0;
            position: absolute;
            top: 0;
            width: 0.5rem;
          }
        `}`
    : `
      background-color: transparent;
      color: inherit;
      `}
  border-radius: ${radius.button};
  border: 0;
  height: 100%;
  padding: 1rem;
  ${({ accentColor }) => accentColor && 'padding-left: 1.5rem;'};
  position: relative;
  text-align: left;
  h1,
  h2,
  h3,
  p {
    font-size: 1rem;
  }
  *:last-child {
    margin-bottom: 0;
  }
  > div {
    height: 100%;
  }
`;
//matches Carousel's padding
export const StackPadding = styled.div `
  padding: 1rem 0;
`;
//# sourceMappingURL=UiListCarousel.styles.js.map